import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, PageShell, EASE } from "@/components/Reveal";

export default function Shiatsu() {
  return (
    <PageShell testid="shiatsu-page">
      <PageHero title="Shiatsu" subtitle="Berührung, die in die Tiefe geht" testid="shiatsu-hero" />

      <section data-testid="shiatsu-content" className="px-6 pb-24 md:px-12 md:pb-36">
        <div className="mx-auto grid max-w-6xl items-start gap-12 md:grid-cols-12 md:gap-10 lg:gap-16">
          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.1, ease: EASE }}
              className="relative"
            >
              <div
                aria-hidden="true"
                className="absolute -left-4 -top-4 h-full w-full rounded-[2.5rem] border border-rot/25"
              />
              <div data-testid="shiatsu-bild" className="relative overflow-hidden rounded-[2.5rem]">
                <motion.img
                  src="/images/shiatsu-behandlung-neu.jpg"
                  alt="Carmen behandelt eine liegende Klientin mit achtsamer Shiatsu-Berührung am Kopf"
                  className="block h-auto w-full"
                  initial={{ scale: 1.06 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.6, ease: EASE }}
                />
              </div>
            </motion.div>
          </div>

          <div className="md:col-span-7 lg:col-span-6">
            <Reveal>
              <p className="text-base leading-loose text-anthrazit/85 md:text-lg">
                Du fühlst dich erschöpft, stehst ständig unter Spannung oder kommst selbst dann
                nicht richtig zur Ruhe, wenn eigentlich Zeit dafür wäre? Dein Kopf läuft weiter,
                dein Körper fühlt sich verspannt an und der Schlaf bringt nicht die Erholung, die du
                brauchst?
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p
                data-testid="shiatsu-statement"
                className="my-12 border-l-2 border-rot pl-7 font-serif text-2xl leading-snug text-rot md:my-14 md:pl-10 md:text-[2rem]"
              >
                Shiatsu hilft deinem Körper, aus diesem Zustand herauszufinden.
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="text-base leading-loose text-anthrazit/85 md:text-lg">
                Durch achtsame, tief wirkende Berührung kann dein Nervensystem zur Ruhe kommen,
                Spannungen können sich lösen und der Atem wieder freier werden. Der Energiefluss
                wird angeregt und du kannst neue Kraft schöpfen und dich wieder wohler und
                lebendiger in deinem Körper fühlen.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-16">
              <Link
                to="/kontakt"
                data-testid="shiatsu-kontakt-link"
                className="group inline-flex items-center gap-4 text-sm uppercase tracking-[0.3em] text-rot"
              >
                <span className="border-b border-rot/40 pb-1 transition-colors duration-500 group-hover:border-rot">
                  Kontakt
                </span>
                <ArrowUpRight
                  size={18}
                  strokeWidth={1.5}
                  className="transition-transform duration-500 group-hover:rotate-45"
                />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
